import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Image from "next/image";
import Button from "../Misc/Button";
import { useAppContext } from "../../_context";
import HighlightedString from "../Misc/HighlightedString";

const CoachesStringersHero = ({ as }) => {
  const [{ tx }] = useAppContext();
  const images = ["/img/heroes/coaches.jpg", "/img/heroes/stringers.jpg"];
  const titles = [
    tx["Calling all [coaches] and [sparring] partners"],
    tx["Professional racket [stringers] wanted"],
  ];
  const bodyText = [
    tx["Grow your coaching business, find new clients and boost your revenue."],
    tx[
      "Our community needs your racket  stringing services and your business needs customers. It’s a win-win."
    ],
  ];
  const buttons = [
    {
      label: tx["Sign up now"],
      href: "/coaches/signup",
    },
    {
      label: tx["Get started"],
      href: "/contact?reason=stringers",
    },
  ];
  const index = ["coaches", "stringers"].indexOf(as);

  return (
    <section className="position-relative coaches-stringers-hero overflow-hidden">
      <Container>
        <Row>
          <Col xs={12} className="position-relative">
            <div className="coaches-stringers-hero-img-cont hero-height">
              <Image
                src={images[index]}
                width={2368}
                height={1600}
                objectPosition="right top"
                objectFit="cover"
                unoptimized={true}
              />
            </div>
            <Col
              md={8}
              lg={6}
              className="blue-content-section text-white px-5 py-7 px-md-7 ms-md-n7 bg-dark-blue">
              <h1>
                <HighlightedString text={titles[index]} />
              </h1>
              <p className="mb-5">{bodyText[index]}</p>
              <Button href={buttons[index].href}>{buttons[index].label}</Button>
            </Col>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CoachesStringersHero;
